module.exports = __webpack_public_path__ + "static/media/total-financial-solutions.289ae85a.png";